(function () {
  if (customElements.get('pair-it-up')) return;

  customElements.define(
    'pair-it-up',
    class PairItUp extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.currencyFormatter = new Intl.NumberFormat(this.dataset.locale || 'en-IN', {
          style: 'currency',
          currency: this.dataset.currency || 'INR',
          maximumFractionDigits: 0,
        });
        this.handleChange = this.onChange.bind(this);
        this.handleDocumentChange = this.onDocumentChange.bind(this);
        this.handleClick = this.onClick.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.addEventListener('change', this.handleChange);
        this.addEventListener('click', this.handleClick);
        document.addEventListener('change', this.handleDocumentChange);
        document.addEventListener('keydown', this.handleKeydown);
        this.updateSummary();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.handleChange);
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('change', this.handleDocumentChange);
        document.removeEventListener('keydown', this.handleKeydown);
      }

      onChange(event) {
        if (event.target.matches('[data-pair-variant]')) this.updateItemPrice(event.target.closest('[data-pair-item]'));
        if (event.target.matches('[data-pair-variant], [data-pair-checkbox]')) this.updateSummary();
      }

      onDocumentChange(event) {
        if (!event.target.matches('product-info form[data-type="add-to-cart-form"] input[name="id"]')) return;

        var currentItem = this.querySelector('[data-current-product="true"]');
        var select = currentItem?.querySelector('[data-pair-variant]');
        if (!select || !Array.from(select.options).some(function (option) { return option.value === event.target.value; })) return;

        select.value = event.target.value;
        this.updateItemPrice(currentItem);
        this.updateSummary();
      }

      onClick(event) {
        var openButton = event.target.closest('[data-pair-open]');
        var closeButton = event.target.closest('[data-pair-close]');
        var addOneButton = event.target.closest('[data-pair-add-one]');
        var addSelectedButton = event.target.closest('[data-pair-add-selected]');

        if (openButton) this.openPanel(openButton);
        if (closeButton) this.closePanel();

        if (addOneButton) {
          var item = addOneButton.closest('[data-pair-item]');
          var variant = item?.querySelector('[data-pair-variant]');
          if (variant?.value) this.addItems([{ id: Number(variant.value), quantity: 1 }], addOneButton);
        }

        if (addSelectedButton) {
          var items = this.getSelectedItems();
          if (items.length) this.addItems(items, addSelectedButton);
        }
      }

      onKeydown(event) {
        if (event.key === 'Escape' && !this.querySelector('[data-pair-panel]')?.hidden) this.closePanel();
      }

      openPanel(trigger) {
        var panel = this.querySelector('[data-pair-panel]');
        if (!panel) return;

        this.panelTrigger = trigger;
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }

      closePanel() {
        var panel = this.querySelector('[data-pair-panel]');
        if (!panel || panel.hidden) return;

        panel.hidden = true;
        this.panelTrigger?.setAttribute('aria-expanded', 'false');
        this.panelTrigger?.focus();
      }

      getSelectedItems() {
        return Array.from(this.querySelectorAll('[data-pair-item]'))
          .filter(function (item) {
            var checkbox = item.querySelector('[data-pair-checkbox]');
            return checkbox?.checked && !checkbox.disabled;
          })
          .map(function (item) {
            return { id: Number(item.querySelector('[data-pair-variant]').value), quantity: 1 };
          })
          .filter(function (item) {
            return Number.isFinite(item.id) && item.id > 0;
          });
      }

      getSelectedOption(item) {
        var select = item?.querySelector('[data-pair-variant]');
        return select?.options[select.selectedIndex];
      }

      updateItemPrice(item) {
        var option = this.getSelectedOption(item);
        if (!item || !option) return;

        var price = Number(option.dataset.price) || 0;
        var comparePrice = Number(option.dataset.comparePrice) || 0;
        var priceElement = item.querySelector('[data-pair-price]');
        var compareElement = item.querySelector('[data-pair-compare-price]');
        var checkbox = item.querySelector('[data-pair-checkbox]');
        var addOneButton = item.querySelector('[data-pair-add-one]');

        if (priceElement) priceElement.textContent = this.formatMoney(price);
        if (compareElement) {
          compareElement.hidden = comparePrice <= price;
          compareElement.textContent = comparePrice > price ? this.formatMoney(comparePrice) : '';
        }
        if (checkbox) {
          checkbox.disabled = option.disabled;
          if (option.disabled) checkbox.checked = false;
        }
        if (addOneButton) addOneButton.disabled = option.disabled;
      }

      updateSummary() {
        var selectedItems = Array.from(this.querySelectorAll('[data-pair-item]')).filter(function (item) {
          var checkbox = item.querySelector('[data-pair-checkbox]');
          return checkbox?.checked && !checkbox.disabled;
        });
        var total = 0;
        var compareTotal = 0;

        selectedItems.forEach(
          function (item) {
            var option = this.getSelectedOption(item);
            var price = Number(option?.dataset.price) || 0;
            var comparePrice = Number(option?.dataset.comparePrice) || 0;
            total += price;
            compareTotal += comparePrice > price ? comparePrice : price;
          }.bind(this)
        );

        var countElements = this.querySelectorAll('[data-pair-count]');
        var totalElements = this.querySelectorAll('[data-pair-total]');
        var compareElements = this.querySelectorAll('[data-pair-compare-total]');
        var addSelectedButton = this.querySelector('[data-pair-add-selected]');

        countElements.forEach(function (element) { element.textContent = String(selectedItems.length); });
        totalElements.forEach(
          function (element) { element.textContent = this.formatMoney(total); }.bind(this)
        );
        compareElements.forEach(
          function (element) {
            element.hidden = compareTotal <= total;
            element.textContent = compareTotal > total ? this.formatMoney(compareTotal) : '';
          }.bind(this)
        );
        if (addSelectedButton) addSelectedButton.disabled = selectedItems.length === 0;
      }

      formatMoney(cents) {
        return this.currencyFormatter.format(cents / 100);
      }

      setLoading(button, isLoading) {
        button.classList.toggle('loading', isLoading);
        button.toggleAttribute('aria-disabled', isLoading);
        button.disabled = isLoading;
        button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
      }

      showMessage(message, isError) {
        var messageElement = this.querySelector('[data-pair-message]');
        if (!messageElement) return;
        messageElement.textContent = message || '';
        messageElement.classList.toggle('pair-it-up__message--error', Boolean(isError));
      }

      async addItems(items, button) {
        if (!items.length || button.getAttribute('aria-disabled') === 'true') return;

        this.setLoading(button, true);
        this.showMessage('', false);

        try {
          var payload = { items: items };
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map(function (section) {
              return section.id;
            });
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement?.(button);
          }

          var response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          var result = await response.json();

          if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add these items.');

          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'pair-it-up',
            productVariantId: items[0].id,
            cartData: result,
          });

          this.closePanel();

          if (this.cart?.tagName === 'CART-DRAWER') {
            this.cart.renderContents(result);
          } else if (this.cart && items.length === 1) {
            this.cart.renderContents(result);
          } else {
            window.location.href = window.routes.cart_url;
            return;
          }

          this.showMessage(items.length > 1 ? 'Selected pieces added to your cart.' : 'Added to your cart.', false);
        } catch (error) {
          this.showMessage(error.message || 'Unable to add these items. Please try again.', true);
        } finally {
          this.setLoading(button, false);
          this.updateSummary();
        }
      }
    }
  );
})();
